import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import SiteLayout from "@/components/site/SiteLayout";
import { HomeSection } from "@/components/site/HomeSections";

const Home = () => {
  const { enabledSections, loading } = useSite();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [location, enabledSections]);

  return (
    <SiteLayout>
      {!loading &&
        enabledSections.map((s) => <HomeSection key={s.key} section={s} />)}
    </SiteLayout>
  );
};

export default Home;
